import { Component, OnInit } from '@angular/core';
import { CommonService } from "../../../../../services/common.service";
import { UserService } from "../../../../../services/user.service";

@Component({
    selector: 'page-info-refund-checkout',
    templateUrl: './index.component.html',
})
export class PageInfoRefundCheckoutComponent implements OnInit {

    /* REFUND POST DATA */
    public refundPostData: any;

    /* FOR TEMPORARY ASSIGNING */
    public tempData: any = {};

    public _: any;

    constructor(
        public commonService: CommonService,
        public userService: UserService,
    ) {
        this._ = this.commonService.getLodash();
    }

    ngOnInit() {
        this.commonService.showPageLoader("読み込み中...");

        /* GET POST DATA */
        this.refundPostData = this.commonService.getData("refundPostData");

        /* CHECK IF HAS DATA */
        if (this._.isEmpty(this.refundPostData)) {
            return this.commonService.redirectToRoute(this.commonService.routePaths.pageHome);
        }

        /* HIDE PAGE LOADER */
        this.commonService.hidePageLoader();
    }

    async submit() {
        /* SHOW PAGE LOADER */
        this.commonService.showPageLoader("最終確認中です。");

        let updatingData = JSON.parse(JSON.stringify(this.refundPostData));
        updatingData = this._.omit(updatingData, [
            "accountSubjects", "reservationID", "customerName", "groupID"
        ]);

        let updatedData = await this.userService.checkUpdateRefundInfo(updatingData);
        if (updatedData.status == "success") {
            /* SAVE DATA */
            this.refundPostData.updatedMessage = updatedData.message;
            this.commonService.setData("refundPostData", this.refundPostData);

            /* REDIRECT TO NEXT PAGE */
            this.commonService.redirectToRoute(this.commonService.routePaths.pageInfoRefundFinish);
        } else {
            this.tempData.submitError = {
                message: updatedData.message,
            }
        }
        /* status: "success", message */

        /* HIDE PAGE LOADER */
        this.commonService.hidePageLoader();
    }

}
